import type { GetLevelSubmissionsRequest, GetLevelSubmissionsResponse } from '@gdladder/shared/features';
import APIClient from '../../../api/APIClient';

export async function getLevelSubmissions({
    twoPlayer,
    levelID,
    page = 1,
    progressFilter = 'victors',
    limit,
    sort,
    sortDirection,
    username,
}: GetLevelSubmissionsRequest & { levelID: number }) {
    const res = await APIClient.get<GetLevelSubmissionsResponse>(`/levels/${levelID}/submissions`, {
        params: {
            page,
            limit,
            twoPlayer,
            username: username || undefined,
            progressFilter,
            sort,
            sortDirection,
        },
    });
    return res.data;
}
